import { SearchBarILS } from "@components/SearchBar";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { SearchHistoryModal } from "@modules/SearchControls/SearchHistory";

export class EnhancedSearchBarILS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSearchHistory: false,
    };
  }

  handleSearch = async (query) => {
    const { onSearchHandler } = this.props;
    onSearchHandler(query);
  };

  toggleSearchHistory = () => {
    this.setState({ showSearchHistory: !this.state.showSearchHistory });
  };

  render() {
    const {
      onSearchHandler,
      onChangeHandler,
      value,
      onFocus,
      onBlur,
      onPasteHandler,
      placeholder,
      className,
      searchHistory,
      isLoadingHistory,
      historyError,
      onDeleteHistoryEntry,
      onClearSearchHistory,
      onRefreshHistory,
      ...otherProps
    } = this.props;

    const { showSearchHistory } = this.state;

    return (
      <div style={{ position: "relative" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "0.5em" }}>
          <div style={{ flex: 1 }}>
            <SearchBarILS
              {...otherProps}
              onSearchHandler={this.handleSearch}
              onChangeHandler={onChangeHandler}
              value={value}
              onFocus={onFocus}
              onBlur={onBlur}
              onPasteHandler={onPasteHandler}
              placeholder={placeholder}
              className={className}
            />
          </div>
        </div>
        <SearchHistoryModal
          open={showSearchHistory}
          onClose={() => this.setState({ showSearchHistory: false })}
          onSearchExecute={this.handleSearch}
          onDeleteEntry={onDeleteHistoryEntry}
          onClearHistory={onClearSearchHistory}
          onRefresh={onRefreshHistory}
          searchHistory={searchHistory}
          isLoadingHistory={isLoadingHistory}
          error={historyError}
        />
      </div>
    );
  }
}

EnhancedSearchBarILS.propTypes = {
  onSearchHandler: PropTypes.func.isRequired,
  onPasteHandler: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  onChangeHandler: PropTypes.func,
  value: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  searchHistory: PropTypes.array,
  isLoadingHistory: PropTypes.bool,
  historyError: PropTypes.string,
  onDeleteHistoryEntry: PropTypes.func.isRequired,
  onClearSearchHistory: PropTypes.func.isRequired,
  onRefreshHistory: PropTypes.func.isRequired,
};

EnhancedSearchBarILS.defaultProps = {
  onPasteHandler: null,
  placeholder: "",
  className: "",
  onChangeHandler: null,
  value: "",
  onFocus: null,
  onBlur: null,
  searchHistory: [],
  isLoadingHistory: false,
  historyError: null,
};
